import { lazy } from "react";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import TaxiAlertIcon from "@mui/icons-material/TaxiAlert";

const AssignCabs = lazy(() => import("../components/assignCabs"));
const AssignedCabView = lazy(() => import("../components/assignCabView"));

const organizationCabRoute = {
  icon: EmojiTransportationIcon,
  name: "Cab Vendor",
  link: "/cab-vendor",
  path: "cab-vendor",
  index: 18,
  superAdminView: false,
  element: "",
  children: [
    {
      path: "cab",
      element: <AssignCabs />,
      name: "Cabs",
      permission: "Assign Cabs-Read",
      link: "/cab-vendor/cab",
      icon: TaxiAlertIcon,
      index: 1,
      superAdminView: false,
    },
    {
      path: "/cab-vendor/cab/:id",
      element: <AssignedCabView />,
    },
  ],
};
export default organizationCabRoute;
